import {takeUntil} from 'rxjs/operators';
import { Component, ElementRef, Renderer2, Inject, forwardRef } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable ,  Subject } from 'rxjs';
import { BaseComponent } from 'sharedFeatures/base';
import { DowngradePopup } from './downgrade-popup.component';
import { DialogCreationService, BillingService } from "sharedFeatures/sharedServices";
import { accountActions } from 'sharedFeatures/store';
import {ISubscriptionDowngradeResponse} from "sharedFeatures/sharedServices/Responses/Subscription/ISubscriptionDowngradeResponse";
import { IErrorResponse, isSuccessResponse } from "sharedFeatures/sharedServices/Responses";

@Component({
    selector: 'downgrade-popup-body',
    templateUrl: './downgrade-popup-body.component.html',
    styleUrls: ['./downgrade-popup-body.component.less']
})

export class DowngradePopupBodyComponent extends BaseComponent {

    public IsDowngradeWithSameFeatures = false;

    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    @select(['account', 'accountData'])
    readonly accountData$!: Observable<any>;
    private accountData: any;

    downgradeText = $localize`Downgrade`;

    packageType: string = '';
    frequency: string = '';

    plansCount: string = '';
    priceInfo: string = '';

    downgradeDate: string = '';

    constructor(
        el: ElementRef,
        r: Renderer2,
        @Inject(forwardRef(() => DowngradePopup)) private parent: DowngradePopup,
        private dialogCreation: DialogCreationService,
        private billingService: BillingService
    ) {
        super(el, r);
    }

    ngOnInit() {
        // Subscribe on the redux store
        this.subscribeReduxStore();
    }

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.accountData$.pipe(
            takeUntil(this.storeUnsubscribe))
            .subscribe(x => this.accountData = x);
    }

    handleDowngrade(): void {

        if (this.packageType == '' || this.frequency == '')
            return;

        this.billingService.ScheduleSubscriptionDowngrade(this.accountData.customerRef, this.accountData.subscriptionRef, this.accountData.ProductId, this.packageType, this.frequency)
            .then((data: ISubscriptionDowngradeResponse | IErrorResponse) => {
                if (isSuccessResponse(data)) {
                    data = data as ISubscriptionDowngradeResponse;
                    accountActions.setSubscriptionDowngradeActive(true);
                    if (data.downgradeDate)
                        accountActions.setSubscriptionDowngradeDate(data.downgradeDate);
                    accountActions.setSubscriptionPriceOption1(this.packageType);
                    accountActions.setSubscriptionPriceOption2(this.frequency);
                }

                if (this.parent.onDowngrade)
                    this.parent.onDowngrade();

                this.parent.close();

            })
            .catch(error => {
                this.dialogCreation.createUnknownExceptionDialog(error).show();
            });

    }

    handleDontDowngrade(): void {

        this.parent.close();

    }

}
